import React, { useState, useEffect } from "react";
import Select from "react-select";
import { createPortal } from "react-dom";

export default function BasicFilter({
    options = [],
    onChange,
    defaultActive,
    isSearchable = false,
    label,
    labelStyle,
    require,
    placeholder = "Select...",
    error,
    className,
}) {
    const [selectedOption, setSelectedOption] = useState(null);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        if (defaultActive) {
            const defaultOption = options.find((o) => o.value === defaultActive);
            setSelectedOption(defaultOption || null);
        }
    }, [defaultActive, options]);

    const handleChange = (option) => {
        setSelectedOption(option);
        if (onChange) onChange(option);
    };

    const portalTarget =
        typeof document !== "undefined" ? document.body : null;

    // Custom react-select styles
    const customStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: "47px",
            border: "none",
            borderRadius: "8px",
            boxShadow: "none",
            backgroundColor: "#fff",
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
            fontWeight: "400",
            cursor: "pointer",
            // padding: "0 12px",
        }),
        placeholder: (base) => ({
            ...base,
            color: "rgba(136, 136, 136, 1)",
            fontFamily: "Poppins, sans-serif",
            fontSize: "12px",
        }),
        singleValue: (base) => ({
            ...base,
            color: "#212121",
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
        }),
        input: (base) => ({
            ...base,
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
        }),
        menu: (base) => ({
            ...base,
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            // zIndex: 1055,
        }),
        menuList: (base) => ({
            ...base,
            maxHeight: "200px",
            overflowY: "auto",

            /* Custom scrollbar */
            "::-webkit-scrollbar": {
                width: "6px",
            },
            "::-webkit-scrollbar-track": {
                background: "#F0F0F0",
                borderRadius: "4px",
            },
            "::-webkit-scrollbar-thumb": {
                background: "#1D2E99", // scrollbar color
                borderRadius: "4px",
            },
            "::-webkit-scrollbar-thumb:hover": {
                background: "#16247A",
            },
        }),


        option: (base, state) => ({
            ...base,
            fontFamily: "Poppins, sans-serif",
            fontSize: "14px",
            backgroundColor: state.isSelected
                ? "rgba(29, 46, 153, 1)"
                : state.isFocused
                    ? "#F5F5F5"
                    : "#fff",
            color: state.isSelected ? "#fff" : "#212121",
            cursor: "pointer",
        }),
        indicatorSeparator: () => ({ display: "none" }),
    };

    return (
        <div className={className}>
            {label && (
                <label
                    className={`${labelStyle || ""} e-primary-font e-text-rich-black e-font-weight-400 line-height-18px e-font-14 padding-6px-bottom`}
                >
                    {label}
                    {require && <span className="e-text-lust">*</span>}
                </label>
            )}

            {/* FIXED HEIGHT LOGIC UPDATED HERE */}
            <div className={!isFocused && !menuIsOpen && !error ? "h-64px" : "h-64px"}>
                <div
                    className={
                        error
                            ? "border-red-1px e-border-radius-8"
                            : isFocused
                                ? "e-border-input-focus e-border-radius-8"
                                : "e-border-input e-border-radius-8"
                    }
                >
                    <Select
                        value={selectedOption}
                        onChange={handleChange}
                        options={options}
                        isSearchable={isSearchable}
                        placeholder={placeholder}
                        classNamePrefix="custom-filter-select"
                        onMenuOpen={() => {
                            setMenuIsOpen(true);
                            // setIsFocused(true);
                        }}
                        // onMenuClose={() => {
                        //     setMenuIsOpen(true);
                        //     setIsFocused(false);
                        // }}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        // menuPortalTarget={portalTarget}
                        menuPosition="fixed"
                        styles={customStyles}
                    />
                </div>

                {error && (
                    <p className="mb-0 e-error-message e-primary-font e-font-10 line-height-12px pt-1">
                        {error}
                    </p>
                )}
            </div>
        </div>
    );
}
